import React from 'react';

import { observer } from 'mobx-react-lite';
import { CalendarListItemType, CalendarAuthType } from 'stores/calendar_auth_store';
import useStores from 'hooks/useStores';


type CalendarAuthContextType = {
    fetchAuthUrl: (identity: string) => Promise<string | null>;
    fetchAvailableCalendars: (identity: string) => Promise<CalendarListItemType[]>;

    addToSyncedCalendars: (identity: string, calendar_id: string) => Promise<boolean>;
    removeFromSyncedCalendars: (identity: string, calendar_id: string) => Promise<boolean>;

    saveCalendarPreferences: (workKey: string, preferences: string) => Promise<string>;
    fetchCalendarPreferences: (workKey: string) => Promise<string>;

    // Contains all known CalendarAuth items
    items: CalendarAuthType[];
}

export const CalendarAuthContext = React.createContext<CalendarAuthContextType>({
    fetchAuthUrl: () => { throw 'Not Implemented' },
    fetchAvailableCalendars: () => { throw 'Not Implemented' },
    addToSyncedCalendars: () => { throw 'Not Implemented' },
    removeFromSyncedCalendars: () => { throw 'Not Implemented' },
    saveCalendarPreferences: () => { throw 'Not Implemented' },
    fetchCalendarPreferences: () => { throw 'Not Implemented' },

    items: [] as CalendarAuthType[],
});



export const CalendarAuthProvider = observer(({ children }: { children: React.ReactNode }) => {
    const { calendarAuthStore } = useStores();

    // const addItems = (newItems: CalendarAuthType[] | CalendarAuthType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setCalendarAuth([...items, ...newItems]);
    // };

    const fetchAuthUrl = async (identity: string) => {
        return calendarAuthStore.fetchAuthUrl(identity);
    };


    const fetchAvailableCalendars = async (identity: string) => {
        return calendarAuthStore.fetchAvailableCalendars(identity);
    };

    const addToSyncedCalendars = async (identity: string, calendar_id: string) => {
        return calendarAuthStore.addToSyncedCalendar(identity, calendar_id);
    };

    const removeFromSyncedCalendars = async (identity: string, calendar_id: string) => {
        return calendarAuthStore.removeFromSyncedCalendars(identity, calendar_id);
    };


    const data = {
        fetchAuthUrl,
        fetchAvailableCalendars,
        addToSyncedCalendars,
        removeFromSyncedCalendars,
        saveCalendarPreferences: calendarAuthStore.setCalendarPreferences,
        fetchCalendarPreferences: calendarAuthStore.fetchCalendarPreferences,
        items: calendarAuthStore.items,
    };

    return (
        <CalendarAuthContext.Provider value={data}>{ children }</CalendarAuthContext.Provider>
    );

});
